export namespace UiContentActions {
  /**
   * Action dedicated to load brand content data
   * Brand content is a concept that comes from Kosmos world.
   *
   * The name refers to how it's configured on COT Tooling.
   * It's a global config table BrandContent
   */
  export class LoadBrandContent {
    public static readonly type = '[Ui Content] Fetch Brand Content (API)';
    constructor(public brand: string) {}
  }
}
